import React from 'react'
import BrandingSection1 from '../sections/BrandingSection1'
import { AwardsComponent } from './Home'
import BrandingSection2 from '../sections/BrandingSection2'
import BrandingSection3 from '../sections/BrandingSection3'
import BrandingSection6 from '../sections/BrandingSection6'
import BrandingExtraSection1 from '../sections/BrandingExtraSection1'
import BrandingExtraSection2 from '../sections/BrandingExtraSection2'
import ServicesShowcase from '../components/ServicesShowcase'
import { useServiceData } from '../context/ServiceDataContext'

const Branding = () => {
  const { getServiceById, getServiceByCategory } = useServiceData();
  // const designServices = getServiceByCategory(`${pathname.split("/")[1]}`);
  const designServices = getServiceByCategory(`design`);
  return (
    <>
      <AwardsComponent />
      <div className='dark:bg-zinc-900 dark:text-white text-black min-h-screen w-full relative z-20'>
        <BrandingSection1 />
        <BrandingExtraSection1 />

        {/* Services Showcase Component */}
        <ServicesShowcase data={designServices} superData={designServices} />
        <BrandingSection2 />

        <BrandingSection3 />

        <BrandingSection6 />

      </div>
    </>
  )
}

export default Branding